import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PaymentModal from '../components/PaymentModal';

function Faturas() {
  const [faturas, setFaturas] = useState([
    {
      id: 1,
      mes: 'Janeiro 2025',
      valor: 88.00,
      vencimento: '15/01/2025',
      status: 'Pago',
      dataPagamento: '10/01/2025',
      codigo: 'FAT001'
    },
    {
      id: 2,
      mes: 'Fevereiro 2025',
      valor: 88.00,
      vencimento: '15/02/2025',
      status: 'Pago',
      dataPagamento: '12/02/2025',
      codigo: 'FAT002'
    },
    {
      id: 3,
      mes: 'Março 2025',
      valor: 88.00,
      vencimento: '15/03/2025',
      status: 'Pendente',
      dataPagamento: null,
      codigo: 'FAT003'
    }
  ]);

  const [userData, setUserData] = useState(null);
  const [selectedFatura, setSelectedFatura] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('unet_user');
    if (user) {
      setUserData(JSON.parse(user));
    }
  }, []);

  const getStatusClass = (status, vencimento) => {
    // Verificar se o boleto está vencido
    const isVencido = () => {
      if (!vencimento) return false;
      const vencimentoDate = new Date(vencimento.split('/').reverse().join('-'));
      const hoje = new Date();
      return vencimentoDate < hoje;
    };

    switch (status.toLowerCase()) {
      case 'pago':
        return 'status-paid';
      case 'pendente':
        return isVencido() ? 'status-overdue' : 'status-pending';
      case 'vencido':
        return 'status-overdue';
      default:
        return 'status-default';
    }
  };

  const getStatusText = (status, vencimento) => {
    // Verificar se o boleto está vencido
    const isVencido = () => {
      if (!vencimento) return status;
      const vencimentoDate = new Date(vencimento.split('/').reverse().join('-'));
      const hoje = new Date();
      return vencimentoDate < hoje;
    };

    if (status.toLowerCase() === 'pendente' && isVencido()) {
      return 'Vencido';
    } else if (status.toLowerCase() === 'pendente') {
      return 'A vencer';
    }
    return status;
  };

  const handlePaymentClick = (fatura) => {
    setSelectedFatura(fatura);
    setShowPaymentModal(true);
  };

  return (
    <div className="faturas-page">
      <div className="container">
        <div className="page-header">
          <h1>Minhas Faturas</h1>
          <p>Acompanhe suas faturas e histórico de pagamentos</p>
        </div>

        {/* Resumo */}
        <div className="summary-cards">
          <div className="summary-card">
            <h3>Total Pago</h3>
            <span className="value">R$ 176,00</span>
            <p>Últimos 3 meses</p>
          </div>
          <div className="summary-card">
            <h3>Próximo Vencimento</h3>
            <span className="value">R$ 88,00</span>
            <p>15/03/2025</p>
          </div>
          <div className="summary-card">
            <h3>Status</h3>
            <span className="value status-good">Em dia</span>
            <p>Nenhuma fatura vencida</p>
          </div>
        </div>

        {/* Lista de Faturas */}
        <div className="faturas-list">
          <div className="list-header">
            <h2>Histórico de Faturas</h2>
            <div className="filters">
              <select className="filter-select">
                <option value="">Todos os status</option>
                <option value="pago">Pago</option>
                <option value="pendente">Pendente</option>
                <option value="vencido">Vencido</option>
              </select>
            </div>
          </div>

          <div className="faturas-table">
            <table>
              <thead>
                <tr>
                  <th>Mês</th>
                  <th>Código</th>
                  <th>Valor</th>
                  <th>Vencimento</th>
                  <th>Status</th>
                  <th>Data Pagamento</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {faturas.map((fatura) => (
                  <tr key={fatura.id}>
                    <td>{fatura.mes}</td>
                    <td>{fatura.codigo}</td>
                    <td>R$ {fatura.valor.toFixed(2)}</td>
                    <td>{fatura.vencimento}</td>
                    <td>
                      <span className={`status-badge ${getStatusClass(fatura.status, fatura.vencimento)}`}>
                        {getStatusText(fatura.status, fatura.vencimento)}
                      </span>
                    </td>
                    <td>{fatura.dataPagamento || '-'}</td>
                    <td>
                      <div className="actions">
                        <button className="btn-action" title="Visualizar">
                          <i className="fas fa-eye"></i>
                        </button>
                        <button className="btn-action" title="Download">
                          <i className="fas fa-download"></i>
                        </button>
                        {(fatura.status === 'Pendente' || getStatusText(fatura.status, fatura.vencimento) === 'Vencido') && (
                          <button 
                            className="btn-action primary" 
                            title="Pagar"
                            onClick={() => handlePaymentClick(fatura)}
                          >
                            <i className="fas fa-credit-card"></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Informações Adicionais */}
        <div className="info-section">
          <div className="info-card">
            <h3>Formas de Pagamento</h3>
            <ul>
              <li><i className="fas fa-credit-card"></i> Cartão de Crédito</li>
              <li><i className="fas fa-university"></i> PIX</li>
              <li><i className="fas fa-barcode"></i> Boleto Bancário</li>
              <li><i className="fas fa-mobile-alt"></i> Débito Automático</li>
            </ul>
          </div>

          <div className="info-card">
            <h3>Precisa de Ajuda?</h3>
            <p>Entre em contato conosco para esclarecer dúvidas sobre suas faturas.</p>
            <div className="contact-actions">
              <Link to="/central/suporte" className="btn-secondary">Abrir Chamado</Link>
              <a href="https://wa.me/5522999611338" target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
                <i className="fab fa-whatsapp"></i> WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Pagamento */}
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        fatura={selectedFatura}
      />
    </div>
  );
}

export default Faturas; 